import React from 'react';

import { Toggle } from 'components';

import styles from 'components/lane/ChannelSettingsEdit/ChannelSettings.scss';
import { useTranslation } from 'react-i18next';

type props = {
  channel: {
    settings: {
      hasMessagingAndMarketplaceEnabled: boolean;
    };
  };
  onChannelUpdated: (channel: any) => void;
  disabled: boolean;
};

export function MessagingAndMarketplaceToggle({
  channel,
  onChannelUpdated,
  disabled = false,
}: props) {
  const { t } = useTranslation();

  return (
    <div className={styles.setting}>
      <Toggle
        disabled={disabled}
        className={styles.toggle}
        testId="hasMessagingAndMarketplaceEnabled"
        value={Boolean(channel.settings.hasMessagingAndMarketplaceEnabled)}
        onChange={enabled =>
          onChannelUpdated({
            settings: {
              ...channel.settings,
              hasMessagingAndMarketplaceEnabled: enabled,
            },
          })
        }
        text={t(
          'web.content.feature.messagingAndMarketplace.toggleFeature.title'
        )}
        description={t(
          'web.content.feature.messagingAndMarketplace.toggleFeature.description'
        )}
      />
    </div>
  );
}
